import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Fab, useMediaQuery, useScrollTrigger, useTheme, Zoom } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { KeyboardArrowUp } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useCollapsed } from './MainLayoutContext';
const SetScrollbarContext = React.createContext(undefined);
export const useScrollBar = () => React.useContext(SetScrollbarContext);
export const MainContent = ({ children }) => {
    const [collapsed] = useCollapsed();
    const [contentNode, setContentNode] = useState(null);
    const scrollbarRef = React.useRef();
    const theme = useTheme();
    const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
    const trigger = useScrollTrigger({
        target: contentNode || window,
        disableHysteresis: true,
        threshold: 100
    });
    const handleScrollToTop = () => {
        contentNode.scrollTo({ top: 0, behavior: 'smooth' });
    };
    useEffect(() => {
        setContentNode(document.querySelector('#swyft-data-content'));
    }, []);
    return (_jsxs(Box, { display: 'flex', flex: '1 1 auto', overflow: 'hidden', pt: 10, pl: isSmDown ? 0 : collapsed ? 10 : 24, children: [_jsx(Box, { display: 'flex', flex: '1 1 auto', overflow: 'hidden', bgcolor: grey[50], children: _jsx(Box, { flex: '1 1 auto', height: '100%', overflow: 'auto', children: _jsx("div", { id: 'swyft-data-content', style: { width: '100%', height: 'calc(100vh - 80px)', overflow: 'auto' }, children: _jsx(SetScrollbarContext.Provider, { value: contentNode, children: children }) }) }) }), _jsx(Box, { position: 'fixed', bottom: '1.5rem', right: '1.5rem', children: _jsx(Zoom, { in: trigger, children: _jsx(Fab, { size: 'small', color: 'secondary', onClick: handleScrollToTop, children: _jsx(KeyboardArrowUp, {}) }) }) })] }));
};
